import React from 'react'

import { Today, DateRange, MailOutline, School } from '@mui/icons-material';

import {getProperty} from "../../helpers/properties";
import { connect } from 'react-redux'

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, sliders }) => {
  const courseSliders = sliders[selectedCourseCode]

  const { sliderItems = [] } = courseSliders.data.find(slider => {
    return slider.id === courseSliders.defaultSlider
  })

  const selectedSliderItem = sliderItems.find(
    sliderItem => sliderItem.id === courseSliders.selectedSlide
  )

  return {
    courseId: selectedCourseCode,
    admissionCategory: selectedCourse.admissionCategory,
    isOffshoreFlag: selectedCourse.isOffshoreFlag,
    activeCalendarType: selectedSliderItem.teachingPeriod
      ? selectedSliderItem.teachingPeriod.calendarType
      : false
  }
}

class SystemLinks extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      vuCalendar_url: getProperty('vuCalendarSiteUrl'),
      vuCollaborate_url: getProperty('vuCollaborateUrl'),
      allocateplus_url: getProperty('allocatePlusSiteUrl'),
      studentemail_link: getProperty('studentEmailLinkUrl')
    }
  }

  componentDidMount() {
  }

  getVUCalendar = () => {
    const calendarlink = !this.props.isOffshoreFlag
    if (calendarlink) {
      return (
        <>
          <li>
            <a href={this.state.vuCalendar_url}>
              <DateRange className="btn-point-events" />
              <span>VU Calendar</span>
            </a>
          </li>
          <li>
            <a href={this.state.allocateplus_url}>
              <Today className="btn-point-events" />
              <span>MyTimetable</span>
            </a>
          </li>
        </>
      )
    }

    return null
  }

  
  getMyTimetable = () => {
    const timetableLink = this.props.isOffshoreFlag
    if (timetableLink) {
      return (
        <li>
          <a href={this.state.allocateplus_url}>
            <Today className="btn-point-events" />
            <span>MyTimetable</span>
          </a>
        </li>
      )
    }

    return null
  }

  render() {
    return (
      <div className="system-links">
        <ul>
          <li>
            <a href={this.state.vuCollaborate_url}>
              <School className="btn-point-events" />
              <span>VU Collaborate</span>
            </a>
          </li>
          {this.getMyTimetable()}
          {this.getVUCalendar()}
          <li>
            <a href={this.state.studentemail_link}>
              <MailOutline className="btn-point-events" />
              <span>Student Email</span>
            </a>
          </li>
        </ul>
      </div>
    )
  }
}

export default connect(mapStateToProps)(SystemLinks)
